<template>
  <PageSecondary>
    <template #title>Клуб Пи⌗⌗⌗</template>
    <h1 style="font-size: xx-large; font-weight: 900;">Просто История</h1>

    <div style="margin: 16px 0;">
      Мы собираемся для общения и обмена добрым, красивым, новым и полезным. Мы слушаем музыку или смотрим кино. Мы варим горячий шоколад.
      Раз в 1-2 недели по вторникам 20:00 - 22:00.
    </div>

    <div style="color:#000; background: #e0e3ff; padding: 8px; font-size: small">
      Встречи в квартире в Москве на паузе и проходит онлайн.
    </div>
    <ul>
      <li><b style="color: #ff005e">9 марта</b></li>
      <li>16 марта</li>
      <li>30 марта</li>
      <li>6 апреля</li>
    </ul>

    <img src="@/assets/handdrawn/club-pi.jpg" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">

    <div style="margin: 16px 0;">
      В клубе ПИ мы следим за языком, способствующим деградации. При его обнаружении участники сигнализируют "ПИИИ!" и помогают иначе сформулировать мысли.
    </div>
    <ul>
      <li>преувеличение или преуменьшение</li>
      <li>обесценивание</li>
      <li>яркая позитивная или негативная оценка</li>
      <li>обвинение</li>
      <li>унижение или насмешки</li>
      <li>умалчивание, обман, ложь</li>
      <li>пустословие</li>
    </ul>

    <img src="@/assets/handdrawn/clear-torch.jpg" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">

    <div style="margin: 16px 0;">
      Звучит как секта праведников? Мы руководствуемся идеей, что язык определяет наше сознание и мысли, а они определяют наше будущее. Помогая друг-другу облагородить язык - мы помогаем друг-другу создать счастливое будущее.
    </div>

    <img src="@/assets/handdrawn/allowed.jpg" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">

    <div style="margin: 16px 0;">
      Цель - создать среду, которая аккумулирует людей, нацеленных на честность, процветание. Это среда - плодородная почва для семян каждого участника.
    </div>

    <div style="font-style: italic; margin-top: 16px; color: red;">
      Условия
    </div>
    <div style="font-style: italic; margin-bottom: 256px; margin-top: 16px;">
      Напиши мне в <TextMe />, познакомимся. Я добавлю тебя в закрытый канал с анонсами.
    </div>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
import TextMe from "@/components/components/TextMe";

export default {
  name: 'ClubPi',
  components: {TextMe, PageSecondary},
  props: {
    secret: String,
  }
}
</script>

<style scoped>

</style>
